import { ConsolidationRuleDTO } from "../DTO/consolidationRuleDTO";
import { ConsolidationRuleDefinition } from "./consolidationRuleDefinition";
import { FieldDefinition } from "./fieldDefinition";

export class ConsolidationRule{

    public id!: number;
    public inputFieldIndex!: number;
    public inputFieldName!: string;
    public consolidationRuleDefinitionId!: number;
    public consolidationRuleDefinition!: ConsolidationRuleDefinition;
    public inputField!: FieldDefinition;
    public consolidationParameter!: string;
    public tempId!: number; //needed for adding/editing new/unsaved rules


    public createInputField(fieldDefinitions:FieldDefinition[]){
        if(this.inputFieldIndex!=undefined) {
            this.inputField = fieldDefinitions.find(f=>f.index==this.inputFieldIndex)!;
        }
    }

    public static mapFromDTO(param:ConsolidationRuleDTO):ConsolidationRule{ 
        if (!param) throw new Error("parameter is null")
        let obj = new ConsolidationRule();
        try
        {
            obj.id = param.id;
            obj.inputFieldIndex = param.inputFieldIndex;
            obj.inputFieldName = param.inputFieldName;
            obj.consolidationRuleDefinitionId = param.consolidationRuleDefinitionId;
            obj.consolidationParameter = param.consolidationParameter;
        }
        catch(e)
        {
            console.log(e);
            
        }
        return obj;
    }

    public static mapToDTO(param:ConsolidationRule):ConsolidationRuleDTO{ 
        if (!param) throw new Error("parameter is null")
        let dto = new ConsolidationRuleDTO();
        try
        {
            dto.id = param.id;
            dto.inputFieldIndex = param.inputField.index;
            dto.inputFieldName = param.inputField.name;
            dto.consolidationRuleDefinitionId = param.consolidationRuleDefinition.id;
            dto.consolidationParameter = param.consolidationParameter;
        }
        catch(e)
        {
            console.log(e);
            
        }
        return dto;
    }

    public clone():ConsolidationRule{
        let mappedConsolidationRule=ConsolidationRule.mapToDTO(this);
        mappedConsolidationRule.id=0;
        let mapFromDTOConsolidationDefinition = ConsolidationRule.mapFromDTO(mappedConsolidationRule);
        mapFromDTOConsolidationDefinition.consolidationRuleDefinition=this.consolidationRuleDefinition;
        mapFromDTOConsolidationDefinition.inputField=this.inputField;
        return mapFromDTOConsolidationDefinition;
    }
}